// assets
import {
    IconBriefcase,
    IconScript,
    IconClipboard,
    IconCheck,
    IconLoader,
    IconLock,
} from "@tabler/icons";

// constant
const icons = {
    IconBriefcase,
    IconScript,
    IconClipboard,
    IconCheck,
    IconLoader,
    IconLock,
};

// ==============================|| SERVICES MENU ITEMS ||============================== //

const services = {
    id: "services",
    title: "Services",
    type: "group",
    children: [
        {
            id: "portfolio",
            title: "Portfolio",
            type: "collapse",
            icon: icons.IconBriefcase,
            defaultOpen: true,

            children: [
                {
                    id: "stock order",
                    title: "Stock Order",
                    type: "item",
                    url: "/services/portfolio/stock-order",
                    icon: icons.IconClipboard,
                    target: false,
                },
                {
                    id: "open positions",
                    title: "Open Positions",
                    type: "item",
                    url: "/services/portfolio/open-positions",
                    icon: icons.IconCheck,
                    target: false,
                },
                {
                    id: "pending orders",
                    title: "Pending Orders",
                    type: "item",
                    url: "/services/portfolio/pending-orders",
                    icon: icons.IconLoader,
                    target: false,
                },
                {
                    id: "closed positions",
                    title: "Closed Positions",
                    type: "item",
                    url: "/services/portfolio/closed-positions",
                    icon: icons.IconLock,
                    target: false,
                },
            ],
        },
        // {
        //     id: "Scripts",
        //     title: "Scripts",
        //     type: "item",
        //     url: "/services/scripts",
        //     icon: icons.IconScript,
        // },
    ],
};

export default services;
